export const APP_LOADING = 'STATUS_APP_LOADING'
export const APP_READY = 'STATUS_APP_READY'
export const EVENT_NOT_FOUND = 'STATUS_EVENT_NOT_FOUND'
export const APP_ERROR = 'STATUS_APP_ERROR'
export const EVENT_OFFLINE = 'STATUS_EVENT_OFFLINE'
export const PASSWORD_REQUIRED = 'STATUS_PASSWORD_REQUIRED'
